import React from "react";
// core components
import * as yup from 'yup';
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";
import "assets/adicional/map.css";
import { get } from '../../utils/ajax.ts';
import XForm from '../../components/forms/XForm.tsx';
import XTextInput from '../../components/inputs/XTextInput.tsx';
import XSelectInput from '../../components/inputs/XSelectInput.tsx';
import XMapsInputReact from '../../components/inputs/XMapsInputReact.tsx';
//import Button from '@material-ui/core/Button';
import "../../utils/lang/i18n";
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import { reqObject, reqString } from '../../data/validations.ts';
import Grid from '@material-ui/core/Grid';
import { toOptions } from '../../components/inputs/inputHelpers.tsx';

import parse from 'html-react-parser';
import Toast from '../../utils/Toast.ts';
import { Button, Container, Row, Col } from "reactstrap";

import {
  distances
} from '../../data/comboCategories.ts';
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  AdvancedMarkerProps,
  APIProvider,
  InfoWindow,
  Map,
  Pin,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import { ContactSupportOutlined } from "@material-ui/icons";

interface IProps {
    data: any | null;
    done?: () => any;
}
type MarkerData = Array<{
  id: string;
  position: window.google.maps.LatLngLiteral;
  type: 'pin' | 'html';
  zIndex: number;
  name: String;
  tipo: String;
  cidade: String;
  tipo: String;
  address: {name: "", country: "", placeId: "", district: "", latitude: ""}
}>;

var marks = Array();

const API_KEY = process.env.REACT_APP_GOOGLE_KEY ?? (process.env.REACT_APP_GOOGLE_KEY);

const schema = yup.object().shape({
    addressInput: yup.string(),
    radiusSelect: reqObject,
    citySelect: reqObject,
    typeSelect: reqObject,
    daySelect: reqObject,    
  });
  
  const initialValues = {
    addressInput: '',
    radiusSelect: '',
    citySelect: '',
    typeSelect: '',
    daySelect: '',
  };



const radians = (degree) => {
  return Math.sin((degree * Math.PI) / 180)
}


const calculateDistance = (point1, point2) => {
  return (
      3959 *
      Math.acos(
          Math.cos(radians(point1.lat)) *
          Math.cos(radians(point2.lat)) *
          Math.cos(radians(point2.lng) - radians(point1.lng)) +
          Math.sin(radians(point1.lat)) * Math.sin(radians(point2.lat)),
      )
  )
}


const GCPage = ({ done }: IProps) => {

  const { t, i18n } = useTranslation();
  const [markers, setMarkers] = React.useState([{}]);
  const [markersGet, setMarkersGet] = React.useState([{}]);
  const [markerInfo, setMarkerInfo] = React.useState(false);
  const [hoverId, setHoverId] = React.useState(null);
  const [dias] = React.useState([]);
  const [tipos] = React.useState([]);
  const [cidades] = React.useState([]);
  const [selectedId, setSelectedId] = React.useState(null);
  const [distance, setDistance] = React.useState(null);
  const [cidade, setCidade] = React.useState(null);
  const [tipo, setTipo] = React.useState(null);
  const [dia, setDia] = React.useState(null);
  const Z_INDEX_SELECTED = markers.length;
  const Z_INDEX_HOVER = markers.length + 1;  
  const [anchorPoint, setAnchorPoint] = React.useState('BOTTOM');
  const [selectedMarker, setSelectedMarker] = React.useState(null);

  const [infoWindowShown, setInfoWindowShown] = React.useState(false);
  const [mapCenter, setMapCenter] = React.useState(false);
  const [autoSelect, setAutoSelect] = React.useState(false);
  const [routeUrl, setRouteUrl] = React.useState([]);
  const [zoom, setZoom] = React.useState(false);
  const onMouseEnter = React.useCallback((id: string | null) => setHoverId(id), []);
  const onMouseLeave = React.useCallback(() => setHoverId(null), []);
  const onMarkerClick = React.useCallback((id: string | null, marker?: window.google.maps.marker.AdvancedMarkerElement, mmm?: Object) => {
      setSelectedId(id);
      if (marker) setSelectedMarker(marker);
      setMarkerInfo(mmm.filter(obj => obj.id === id)[0]);

      if (id !== selectedId) {
        setInfoWindowShown(true);
      } else {
        setInfoWindowShown(isShown => !isShown);
      }
    },
    [selectedId]
  );

  React.useEffect(() => {
    const asyncGetCall = async () => {
      try {
        const response = await fetch('https://api.igrejaconectados.com.br/api/groups/combo/gcs?categories[]=Localiza%C3%A7%C3%A3o%20GC%20Curitiba%20e%20Regi%C3%A3o&churchName=Conectados');
        let resp = await response.json();
        const data: MarkerData = [];
        resp.forEach((dados, index) => {
          
          data.push({
            id: index,
            position: {lat: dados.address.latitude, lng: dados.address.longitude},
            zIndex: index,
            type: 'pin',
            titulo: dados.name,
            whats: dados.details,
            address: dados.address,
            details: dados.details,
            distance: false,
            cidade: dados?.cidade,
            tipo: dados?.tipo,
            dia: dados?.dia

          });
        }); 
      
        var cc = Object.groupBy(data, ({ cidade }) => cidade);
        var tt = Object.groupBy(data, ({ tipo }) => tipo);
        var dd = Object.groupBy(data, ({ dia }) => dia);
        Object.keys(cc).forEach(function (key) {
          if (key != "undefined") {
            if (!cidades.includes(key)) {
              cidades.push(key);
            }
          }
        });
        Object.keys(tt).forEach(function (key) {
          if (key != "undefined") {
            if (!tipos.includes(key)) {
              tipos.push(key);
            }
          }
        }); 
        Object.keys(dd).forEach(function (key) {
          if (key != "undefined") {
            if (!dias.includes(key)) {
              dias.push(key);
            }
          }
        });               
        setMarkers(data);
        setMarkersGet(data);
      } catch(error) {
        console.log(error)
      } 
    }
    asyncGetCall();
  }, []);  

  /**
   * Ao selecionar uma distância
   * @param {value} value 
   */
  const onChangeDistance = (value) => {
    //Pega apenas o número no retorno
    setDistance(value.replace(/[^0-9]/g,''));
  }

  /**
   * Ao selecionar uma cidade
   * @param {value} value 
   */
  const onChangeCidade = (value) => {
    setCidade(value);
  }

  /**
   * Ao selecionar um tipo
   * @param {value} value 
   */
  const onChangeTipo = (value) => {
    setTipo(value);
  }

  const onChangeDia = (value) => {
    setDia(value);
  }

  const onMapClick = React.useCallback(() => {
    setSelectedId(null);
    setSelectedMarker(null);
    setInfoWindowShown(false);
    setZoom(false);
    setMapCenter(false);
    
  }, []);

  const handleInfowindowCloseClick = React.useCallback(
    () => setInfoWindowShown(false),
    []
  );

  const makerListClick = (e) => {
    let m = markersGet[e.currentTarget.getAttribute('value')];
    setMapCenter(m.position);    
    setZoom(15);
    setTimeout(function() {
      new window.google.maps.event.trigger( marks[m.id], 'click' );
    }, 500);
  }

  /**
   * Objeto que alimenta as <li></li> do lado esquerdo
   * @returns Object
   */
  const CreateLocationList = () => {
    return (
      markersGet.map((list,index) =>
        <li value={index} onClick={makerListClick} className="list-marker locationlistitem marker" data-index={index} data-lat={list.address?.latitude} data-lng={list.address?.longitude}>
          <div class="list-details" title="__distance__">
            <div class="list-content">
              <div class="name">{list.titulo} </div>
              <div class="address"><i class="fa-solid fa-location-dot"></i> {list.address?.name}</div>
              <div><i class="fa-solid fa-people-group"></i> Tipo do Grupo: {list.tipo}</div>
              <div><i class="fa-solid fa-clock"></i> Dia e hora do encontro: {list.dia}</div>
              {/*<div class="telephone"><a href="tel:__tel__">__tel__</a></div>*/}
              <div class="direction">
                <a href={getDirectionUrl(list.address?.district, list.address?.latitude, list.address?.longitude)} target="_blank"><i class="fa-solid fa-route"></i> Criar rota</a>
              </div>
            </div>
          </div>
        </li>
     )
    );
  }

  const onChangeAutoSelect = (e) => {
    if (e.length <= 0) {
      //setAutoSelect(false);
    }
  }

  /**
   * Método para filtar os campos da busca nas marcações
   */
  const filtro = async () => {
    let retorno = false;
    if (selectedPlace) {
      retorno = await Promise.all(markers.map(data => {
        let distancia = false;
        distancia = calculateDistance(
          {lat: selectedPlace.geometry.location?.lat(), lng: selectedPlace.geometry.location?.lng()},
        {lat: data.address.latitude, lng: data.address.longitude},
        );
        return { ...data, distance: distancia };
      }));
      if (distance) {
        retorno = await Promise.all(retorno.filter(data => data.distance <= distance).sort((a,b) => a.distance - b.distance));
      } 
    } else {
      retorno = markers;
    }
    if (cidade) {
      retorno = await Promise.all(retorno.filter(data =>  data.cidade === cidade));
    } 
    if (tipo) {
      retorno = await Promise.all(retorno.filter(data =>  data.tipo == tipo));
    }  
    if (dia) {
      retorno = await Promise.all(retorno.filter(data =>  data.dia == dia));
    }     
    setMarkersGet(retorno);
    setZoom(11);
    //setSelectedId(null);
    //setInfoWindowShown(false);    
  }

  const onMarkerSelected = async (marker) => {
    setAutoSelect(marker);
    setMarkersGet(markers);
    filtro();      
  }

  const [selectedPlace, setSelectedPlace] = React.useState(null); 
  const [valueAuto, setValueAuto] = React.useState(null);
  
  function handleSubmit(values: any, actions: FormikHelpers<any>) {
    //setMarkers(markers);
    setMarkersGet(markers);

  }
  React.useEffect(() => {
    onMarkerSelected(false);
  }, [cidade, tipo, dia]);

  React.useEffect(() => {
    if(distance) {
      if (window.google.maps.Geocoder) {
        let geocoder = new window.google.maps.Geocoder;
        //Seta as opções
        let options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        };
        //Cria a função constante do sucesso
        const success = (pos) => {
          let crd = pos.coords;
          const pp = {
            lat: crd.latitude,
            lng: crd.longitude,
          };
          geocoder.geocode({'location': pp}, function(results, status) {
            setValueAuto(results[0].formatted_address);
            onMarkerSelected(results[0]);
          });   
        };

        //Cria a função constante do erro
        const errors = (err) => {
          console.warn(`ERROR(${err.code}): ${err.message}`);
        }
        if (selectedPlace) {
          onMarkerSelected(selectedPlace);
          
        } else {
          if (navigator.geolocation) {
            Toast.info('Você não digitou nenhum endereço no campo "Seu endereço", o sistema vai tentar detectar a sua localização atual, pode aparecer um popup solicitando sua permissão para identificarmos.');
            navigator.permissions
            .query({ name: "geolocation" })
            .then(function (result) {
                console.log(result);

                if (result.state === "granted") {
                  //If granted then you can directly call your function here
                  navigator.geolocation.getCurrentPosition(success, errors, options);
                } else if (result.state === "prompt") {
                  //If prompt then the user will be asked to give permission
                  navigator.geolocation.getCurrentPosition(success, errors, options);
                } else if (result.state === "denied") {
                  Toast.error('Foi negado a permissão para localização do seu endereço, por favor preencha o campo "Seu endereço" criar uma rota pela distância.');
                  //If denied then you have to show instructions to enable location
                }            
            });
          } else {
            Toast.error('Geolocation is not supported by this browser.');
          }
        }
      }
    }
  }, [distance]);

  const handleZoomChange = (event: any) => {
    setZoom(event?.detail?.zoom);
    setMapCenter(false);
    setSelectedId(null);
    setInfoWindowShown(false);  
  };
  const handleReset = (e) => {
    setSelectedId(null);
    setCidade(false);
    setZoom(11);
    setTipo(false);
    setDistance(false);
    setDia(false);
    setMarkerInfo(false);
    setSelectedMarker(false);
    setSelectedPlace(false);
  }
  const setMarks = (id, marker) => {
    marks[id] = marker;
  }
  const getDirectionUrl = (address, lat, lng) => {
    if (selectedPlace) {
      return `https://www.google.com/maps?f=d&saddr=${selectedPlace.formatted_address}&daddr=${address}&dirflg=d`;
    } else {
      return `https://www.google.com/maps/dir/Current+Location/${address}/@${lat},${lng},15z`;
    }
    
  }
  return ( 
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="main">
          <section className="mapa">
          <APIProvider apiKey={API_KEY} language={i18n.language == 'pt_br'?  'pt-br' : 'en'} region={'BR'}>
            <div className="filter-wrap">
              {/** Formulário de busca no topo */}
              <XForm
                  onSubmit={handleSubmit}
                  schema={schema}
                  initialValues={initialValues}
                  buttonDisable={true}
                  className={"w-100"}
                  onReset={handleReset}
              >      
                <div style={{ padding: 8 }}>
                  <Grid spacing={2} container className="min-width-100">
                    <Grid item xs={12} md={4}>
                      <XMapsInputReact
                        name="addressInput"
                        placeholder={t("Enter your address...")}
                        label={t('Your address')}
                        type="text"
                        variant="outlined"
                        margin="none"
                        value={valueAuto}
                        setValue={setValueAuto}
                        onMarkerSelected={onMarkerSelected}
                        onPlaceSelect={setSelectedPlace}
                        onChange={onChangeAutoSelect}
                        InputLabelProps={{ shrink: true }}
                      />                

                    </Grid>
                    <Grid item xs={12} md={2}>
                      <XSelectInput
                        name="distance"
                        label={t('How far?')}
                        onChange={onChangeDistance}
                        options={toOptions(distances)}
                        variant="outlined"
                        margin="none"
                      />                    
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <XSelectInput
                        name="city"
                        label={t('City')}
                        onChange={onChangeCidade}
                        options={toOptions(cidades)}
                        variant="outlined"
                        margin="none"
                      />                    
                    </Grid> 
                    <Grid item xs={12} md={1}>
                      <XSelectInput
                        name="type"
                        label={t('Type')}
                        onChange={onChangeTipo}
                        options={toOptions(tipos)}
                        variant="outlined"
                        margin="none"
                      />                    
                    </Grid>
                    <Grid item xs={12} md={1}>
                      <XSelectInput
                        name="day"
                        label={t('Day')}
                        onChange={onChangeDia}
                        options={toOptions(dias)}
                        variant="outlined"
                        margin="none"
                      />                    
                    </Grid>                                     
                    <Grid item xs={12} md={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}  
                        size="large"
                        style={{ margin: 6 }}
                        type="reset"
                      >
                        <Trans>Reset</Trans>
                      </Button>                  
                    </Grid>
                  </Grid>
                </div>
              </XForm>
            </div>
            {/** Lista dos endereços na esquerda */}
            <div className="flex wrapper">
              <div className="address-list-wrap">
                  <ul className="list-wrap" id="locationListWrapper">
                      {/*<li className="list-marker">
                          <div className="spinner"></div>
                      </li>*/}
                      <CreateLocationList/>
                  </ul>
              </div>
              {/** Mapa */}
              
                <Map
                  defaultZoom={11}
                  defaultCenter={{lat: -25.4790106, lng: -49.3057556}}
                  gestureHandling={'greedy'}
                  onClick={onMapClick}
                  id="map"
                  disableDefaultUI={false}
                  mapId={'bf51a910020fa25a'}
                  center={mapCenter}
                  zoom={zoom}
                  onZoomChanged={handleZoomChange}
                  
                >
                  {markersGet.map(({id, zIndex: zIndexDefault, position, type}) => {
                    
                    let zIndex = zIndexDefault;
                    if (hoverId === id) {
                      zIndex = Z_INDEX_HOVER;
                    }

                    if (selectedId === id) {
                      zIndex = Z_INDEX_SELECTED;
                    }
                  
                    if (type === 'pin') {
                      return (
                        <AdvancedMarkerWithRef
                          onMarkerClick={(
                            marker: window.google.maps.marker.AdvancedMarkerElement
                          ) => onMarkerClick(id, marker, markersGet)}
                          onMouseEnter={() => onMouseEnter(id)}
                          onMouseLeave={onMouseLeave}
                          getId={id}
                          setMarks={setMarks}
                          key={id}
                          zIndex={zIndex}
                          className={"marker-" + id}
                          style={{
                            transform: `scale(${[hoverId, selectedId].includes(id) ? 1.4 : 1})`
                          }}
                          
                          position={position}>
                          <Pin
                            background={selectedId === id ? '#22ccff' : null}
                            borderColor={selectedId === id ? '#1e89a1' : null}
                            glyphColor={selectedId === id ? '#0f677a' : null}
                          />
                        </AdvancedMarkerWithRef>
                      );
                    }
                  })}
                  {infoWindowShown && selectedMarker &&(
                    <InfoWindow
                      anchor={selectedMarker}
                      onCloseClick={handleInfowindowCloseClick}>
                      <h2>{markerInfo.titulo}</h2>
                      {/*<h4>Este seria o lugar mais perto!</h4>*/}
                      
                      <p><i class="fa-solid fa-location-dot"></i> <strong>Endereço:</strong> {markerInfo?.address?.district}</p>
                      <p><i class="fa-solid fa-people-group"></i> <strong>Tipo do Grupo:</strong> {markerInfo?.tipo}</p>
                      <p><i class="fa-solid fa-calendar-days"></i> <strong>Dia do Encontro:</strong> {markerInfo?.dia}</p>
                      { markerInfo?.distance &&
                      <p><i class="fa-solid fa-location-dot"></i> <strong>Distancia:</strong> {markerInfo?.distance.toFixed(2)} km</p>
                      }
                      
                      
                    </InfoWindow>
                  )}
                </Map>
                      
            </div>      
            </APIProvider>  
          </section>               
        </div>
        <div
          className="section section-download"
          data-background-color="black"
          id="download-section"
        >
          <Container>
            <Row className="justify-content-md-center">
              <Col className="text-center" lg="8" md="12">
                <h2 className="title">
                  GC Conectados Online
                </h2>
                <h4 className="description">
                  Você não encontrou um GC perto da sua residência ou cidade? Faça parte da Conectados Online um grupo especialmente para você!
                </h4>
              </Col>
              <Col className="text-center" lg="8" md="12">
                <Button
                  className="btn-round"
                  color="info"
                  href="https://api.whatsapp.com/send?phone=5511958678761&text=Ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es+para+participar+do+GC+Online.+"
                  role="button"
                  size="lg"
                >
                  Mais informações
                </Button>
              </Col>
            </Row>
          </Container>
        </div>           
        <Footer />
      </div>
    </>
  );
}

export default GCPage;

export const AdvancedMarkerWithRef = (
  props: AdvancedMarkerProps & {
    onMarkerClick: (marker: window.google.maps.marker.AdvancedMarkerElement) => void;
  }
) => {
  const {children, getId, setMarks, onMarkerClick, ...advancedMarkerProps} = props;
  const [markerRef, marker] = useAdvancedMarkerRef();
  setMarks(getId, marker);
  return (
    <AdvancedMarker
      onClick={() => {
        if (marker) {
          onMarkerClick(marker);
        }
      }}
      ref={markerRef}
      {...advancedMarkerProps}>
      {children}
    </AdvancedMarker>
  );
};
